import styled from 'styled-components';
import { InlineAlert } from '@amzn/storm-ui';

export const ArtEventDropdownContainer = styled.div`
  padding: 1rem 0;
  && label {
    color: ${({ theme }) => theme.color.gray[50]};
  }
`;

export const AlertWrapper = styled.div`
  && {
    margin-top: 0.5rem;
  }

  && * {
    font-size: 0.75rem;
    padding: 0;
    margin: 0;
  }
`;

export const StyledInlineAlert = styled(InlineAlert)`
  margin-top: 0.5rem;
  && * {
    color: ${({ theme }) => theme.color.gray[50]};
  }
`;
